import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
function MuiInput(props) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (props?.autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [props?.autoFocus]);

  const onChangeInput = (e) => {
    const value = e.target.value;
    const number = value.replace(/\D/g, "");
    const text = value.replace(/[^a-zA-Z]/g, "");
    if (props?.handleChange) {
      props.handleChange(e);
    }
    if (number.length >= 0 && props?.getInputNumber) {
      e.target.value = number;
      props.getInputNumber(e);
    }
    if (
      number.length >= 0 &&
      number.length <= 10 &&
      props?.getInputPhoneNumber
    ) {
      e.target.value = number.slice(0, 10);
      props?.getInputPhoneNumber(e);
    }
    if (text.length >= 0 && props?.getInputText) {
      e.target.value = text;
      props?.getInputText(e);
    }
  };

  const getPasswordFieldClasses = () => {
    if (props?.isPasswordField) {
      return `relative ${props?.passwordInputDivStyles || ""}`;
    }
    return "";
  };

  return (
    <div className="mb-1">
      <div className={getPasswordFieldClasses()}>
        <TextField
          label={props?.label}
          variant="outlined"
          fullWidth
          sx={{
            ".MuiInputBase-root": {
              height: "50px", // Set your desired height here
            },
            ".MuiOutlinedInput-root": {
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#3C50E0",
              },
            },
            ".MuiInputLabel-root.Mui-focused": {
              color: "#3C50E0",
            },
          }}
          ref={inputRef}
          autoFocus={props.autoFocus}
          autoComplete={"off"}
          name={props?.name}
          placeholder={`${props?.placeholder || ""} `}
          value={props?.value || ""}
          required={props?.required}
          disabled={props?.disabled}
          style={{ color: props?.disabled ? "#A0A0A0" : "inherit" }}
          onChange={props?.onChange || onChangeInput}
          type={props?.type}
          readOnly={props?.readOnly || false}
          onKeyDown={props?.onKeyDown}
          onFocus={props?.onFocus}
          onBlur={props?.onBlur}
          maxLength={props?.maxLength}
        />
        {/* <input
                    ref={inputRef}
                    autoComplete={"off"}
                    name={props?.name}
                    placeholder={`${props?.placeholder || ""} `}
                    value={props?.value || ""}
                    required={props?.required}
                    disabled={props?.disabled}
                    style={{ color: props?.disabled ? "#A0A0A0" : "inherit" }}
                    className={`w-full rounded border-[1px] border-stroke bg-transparent py-2 px-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary required-field  ${props?.className}`}
                    onChange={props?.onChange || onChangeInput}
                    type={props?.type}
                    readOnly={props?.readOnly || false}
                    onKeyDown={props?.onKeyDown}
                    onFocus={props?.onFocus}
                    onBlur={props?.onBlur}
                    maxLength={props?.maxLength}
                /> */}
        {props?.regeneratePasswordOption && !props?.regeneratePassword ? (
          <Tooltip title="Regenerate Password">
            <button
              type="button"
              onClick={props.onClickRegeneratePasswordIcon}
              className="h-6 w-6 absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-primary bg-transparent border-none outline-none p-0 flex items-center justify-center"
              aria-label="Regenerate Password"
            >
              <img
                src="/images/reset-password.png"
                alt="Reset Password"
                className="h-6 w-6"
              />
            </button>
          </Tooltip>
        ) : (
          props?.isPasswordField && (
            <Tooltip
              title={
                !props?.toggleEyeIconState ? "View Password" : "Hide Password"
              }
            >
              <button
                type="button"
                onClick={props?.toggleEyeIcon}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-primary bg-transparent border-none outline-none p-0 flex items-center justify-center"
                aria-label={
                  props?.toggleEyeIconState ? "Hide Password" : "View Password"
                }
              >
                <FontAwesomeIcon
                  icon={props?.toggleEyeIconState ? faEyeSlash : faEye}
                  className="w-5 h-5"
                />
              </button>
            </Tooltip>
          )
        )}
      </div>
      <div
        className={`text-xs mt-1 h-[1em] flex transition-opacity duration-150 relative ${
          props.error ? "text-[#FF0000]" : "text-[#4255ac]"
        } ${props?.error || props.message ? "opacity-100" : "opacity-0"} ${
          props.errorDivCustomStyles
        }`}
      >
        {props?.error || props?.message}
      </div>
    </div>
  );
}

MuiInput.propTypes = {
  // Basic input props
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  maxLength: PropTypes.number,

  // Event handlers
  onChange: PropTypes.func,
  handleChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,

  // Specialized input handlers
  getInputNumber: PropTypes.func,
  getInputPhoneNumber: PropTypes.func,
  getInputText: PropTypes.func,

  // Label and validation
  label: PropTypes.string,
  error: PropTypes.string,
  message: PropTypes.string,
  errorDivCustomStyles: PropTypes.string,

  // Password field specific
  isPasswordField: PropTypes.bool,
  passwordInputDivStyles: PropTypes.string,
  toggleEyeIcon: PropTypes.func,
  toggleEyeIconState: PropTypes.bool,
  regeneratePasswordOption: PropTypes.bool,
  regeneratePassword: PropTypes.bool,
  onClickRegeneratePasswordIcon: PropTypes.func,
};
export default MuiInput;
